import { createTheme, type Theme } from '@mui/material/styles';

import appThemeV2 from 'theme/themeV2';
import type { DomainPalette } from 'utils/domainPalette';

export function createDomainTheme(palette: DomainPalette): Theme {
    return createTheme(appThemeV2, {
        palette: {
            primary: {
                main: palette.primary,
                dark: palette.primaryDark,
                light: palette.primaryLight,
                contrastText: palette.onPrimary,
            },
        },
    });
}
